import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "../lib/auth";
import { AuthShell, AuthField } from "../components/AuthShell";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      nav(res.user.role === "admin" ? "/admin" : "/dashboard");
    } else {
      setErr(res.error);
    }
  };

  return (
    <AuthShell>
      <span className="overline">Sign in</span>
      <h1 className="font-serif" style={{ fontSize: "clamp(2rem, 4vw, 2.8rem)", fontWeight: 500, letterSpacing: "-0.01em", margin: "12px 0 8px" }}>
        Welcome <em style={{ fontStyle: "italic", color: "var(--secondary)" }}>back</em>.
      </h1>
      <p style={{ color: "var(--text-muted)", marginBottom: 28, maxWidth: 440, lineHeight: 1.55 }}>
        Sign in to pick up right where you left off with your home sale.
      </p>
      <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 22 }}>
        <AuthField label="Email" testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" autoFocus />
        <AuthField label="Password" testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
        {err && <div data-testid="login-error" style={{ color: "var(--error)", fontSize: 14 }}>{err}</div>}
        <button data-testid="login-submit-btn" className="btn-primary" type="submit" disabled={busy} style={{ marginTop: 6, alignSelf: "flex-start" }}>
          {busy ? "Signing in…" : <>Sign in <ArrowRight size={16} /></>}
        </button>
      </form>
      <div style={{ marginTop: 28, color: "var(--text-muted)", fontSize: 14 }}>
        New here?{" "}
        <Link data-testid="link-to-register" to="/register" style={{ color: "var(--primary)", fontWeight: 500 }}>Create an account</Link>
        <span style={{ margin: "0 8px", opacity: 0.4 }}>·</span>
        <Link data-testid="forgot-password-link" to="/forgot" style={{ color: "var(--text-muted)" }}>Forgot password?</Link>
      </div>
    </AuthShell>
  );
}
